import service from "../util/http";

// 当前登录用户在 KD 角色范围内的国家列表
export const getKdScopeCountries = () => {
  return service({
    url: "manage/kd/feedback/question/scopeCountries",
    method: "get",
  });
};

// 表单重置
export const feedbackFormReset = (feedbackFormId) => {
  return service({
    url: "manage/kd/feedbackForm/reset?feedbackFormId=" + feedbackFormId,
    method: "post",
  });
}

// 问题重置
export const feedbackQuestionReset = (questionId) => {
  return service({
    url: "manage/kd/feedbackForm/resetByQuestionId?questionId=" + questionId,
    method: "post",
  });
}
// 退回问题
export const feedbackQuestionBack = (questionId) => {
  return service({
    url: "manage/kd/feedbackForm/resetToNode?questionId=" + questionId,
    method: "post",
  });
}

// 流程及问题关闭
export const feedbackFormFinishKd = (questionId) => {
  return service({
    url: "manage/kd/feedbackForm/finish?questionId="+ questionId,
    method: "post",
  });
}

// 反馈单删除(质量反馈开发)
export const feedbackFormDelete = (feedbackFormId) => {
  return service({
    url: "manage/kd/feedbackForm/delete?feedbackFormId=" + feedbackFormId,
    method: "post",
  });
}

// 质量反馈单删除
export const deleteEmptyFormApi = (questionId) => {
  return service({
    url: "manage/kd/feedbackForm/deleteEmptyForm?feedbackFormId=" + questionId,
    method: "post",
  })
}

// 新增质量反馈KD列表
export const feedbackListApi = data => {
  return service({
    url: "manage/kd/feedback/question/list",
    method: "post",
    data
  });
};

// KD质量反馈问题数量统计（关闭数/关闭率）
export const closeStatApi = data => {
  return service({
    url: "/manage/kd/feedback/question/closeStat",
    method: "post",
    data
  });
};

// KD质量反馈进度统计
export const progressStatApi = data => {
  return service({
    url: "/manage/kd/feedback/question/progressStat",
    method: "post",
    data
  });
};

// KD质量反馈问题处理时效统计
export const timelinessStatApi = data => {
  return service({
    url: "/manage/kd/feedback/question/timelinessStat",
    method: "post",
    data
  });
};


// KD质量反馈进度统计下拉汇总
export const progressStatOptionsApi = () => {
  return service({
    url: "/manage/kd/feedback/question/progressStatOptions",
    method: "post"
  });
};

// KD质量反馈关闭率统计下拉汇总
export const closeStatOptionsApi = () => {
  return service({
    url: "/manage/kd/feedback/question/closeStatOptions",
    method: "post"
  });
};

// 问题列表详情
export const feedbackDetailApi = data => {
  return service({
    url: "manage/kd/feedback/question/detail",
    method: "get",
    params:data
  });
};

// 质量反馈KD提交
export const feedbackSubmitApi = data => {
  return service({
    url: "/manage/kd/feedback/question/submit",
    method: "post",
    data
  });
};

// 新增质量反馈KD问题列表
export const questionListApi = data => {
  return service({
    url: "/manage/kd/feedback/question/questionListByForm",
    method: "post",
    data
  });
};

// 获取审批流程图
export const getFlowDiagram = questionId => {
  return service({
    url: "/manage/kd/feedback/question/diagram?questionId=" + questionId,
    method: "post"
  });
};

// 新增质量反馈KD问题删除
export const problemDeleteApi = data => {
  return service({
    url: "/manage/kd/feedback/question/removeQuestion",
    method: "post",
    data
  });
};


/**
 * 获取问题流程信息
 * @param data
 * @return {*}
 */
export const requestQuestionFlowInsInfoKD = data => {
  return service({
    url: "/manage/kd/feedback/question/getFlowByQuestionId",
    method: "get",
    params:data
  });
};

// 新增质量反馈KD问题新增
export const problemAddApi = data => {
  return service({
    url: "/manage/kd/feedback/question/add",
    method: "post",
    data
  });
};

// 新增附言
export const addPostscriptApi = data => {
  return service({
    url: "/manage/kd/feedback/question/addPostscript",
    method: "post",
    data
  });
};
// 新增KD质量反馈问题编辑
export const problemEditApi = data => {
  return service({
    url: "/manage/kd/feedback/question/edit",
    method: "post",
    data
  });
};

// 质量反馈列表
export const problemListApi = data => {
  return service({
    url: "/manage/kd/feedback/question/questionList",
    method: "post",
    data
  });
};

// 质量问题导出
export const problemExportApi = data => {
  return service({
    url: "manage/kd/feedback/question/exportDataList",
    method: "post",
    responseType: "blob",
    data
  });
};

// 历史记录查询
// 审核类型 0:有解决方案 1:类型一 2:类型二(附件) 只有应急措施 3:类型三
export const queryHistoryList = data => {
  return service({
    url: "/manage/kd/feedback/question/auditHistoryOperatioList",
    method: "post",
    data
  });
};

// 审核
export const auditProblem = data => {
  return service({
    url: "/manage/kd/feedback/question/audit",
    method: "post",
    data
  });
};

// 审核不保存数据
export const auditProblemNot = data => {
  return service({
    url: "/manage/kd/feedback/question/auditNotSave",
    method: "post",
    data
  });
};

// 已有应急措施列表
export const getEmergencyMeasureListApi = data => {
  return service({
    url: "/manage/kd/feedback/question/emergencyMeasureList",
    method: "post",
    data
  });
};

// 审核记录
export const auditHistoryList = data => {
  return service({
    url: "/manage/kd/feedback/question/auditHistoryList",
    method: "post",
    data
  });
};

// 请求提交审核
export const requestSubmitAuditKD = data => {
  return service({
    url: "/manage/kd/feedback/question/audit",
    method: "post",
    data
  });
};

// 查询巡检记录
export const getInspectRecordListApi = data => {
  return service({
    url: "/manage/kd/feedback/question/inspectRecordList",
    method: "post",
    data
  });
};

// 上传巡检记录
export const addInspectRecordApi = data => {
  return service({
    url: "/manage/kd/feedback/question/addInspectRecord",
    method: "post",
    data
  });
};

// 切换问题有效状态（启用/停用）
export const switchValidStatus = (questionId) => {
  return service({
    url: "manage/kd/feedback/question/switchValidStatus?questionId=" + questionId,
    method: "post"
  });
};
